module.exports = __webpack_public_path__ + "media/stylesheets/images/staff/hero-mobile_2-57c3c01689e609ecf78275fc80b09cd8.png";